import{useContext as o}from"react";import{AlgoliaApiKeyContext as t}from"./AlgoliaApiKeyContext.js";const r=()=>o(t);export{r as useAlgoliaApiKeyContext};
